var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("MainLayout", { staticClass: "video-course-details" }, [
    _c(
      "div",
      {
        staticClass: "container mw-960",
        attrs: { slot: "action-bar" },
        slot: "action-bar"
      },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-6 col-lg-7" }, [
            _c(
              "h5",
              {
                staticClass:
                  "action-header video-course-details__header-title typography--headline typography--color-secondary pt-1 pl-10-mobile pr-10-mobile",
                attrs: {
                  title:
                    _vm.$t("video_lectures.sub_header.video_courses") +
                    " > " +
                    _vm.courseTitle
                }
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("video_lectures.sub_header.video_courses")) +
                    " > " +
                    _vm._s(_vm.courseTitle) +
                    "\n        "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "typography--body-2 typography--color-secondary" },
              [
                _vm.courseDomainName
                  ? _c("span", [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("series_cards.chapters.meta.domain")) +
                          ":\n            " +
                          _vm._s(_vm.courseDomainName) +
                          "\n          "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.courseDomainName
                  ? _c("span", { staticClass: "ml-6 mr-6" }, [
                      _vm._v("\n            |\n          ")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.$t("video_lectures.video_course.lecture_count", {
                          count: _vm.lectureCount
                        })
                      ) +
                      "\n          "
                  )
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-6 col-lg-5 hidden-sm-down" }, [
            _c(
              "div",
              { staticClass: "action-btn-row" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "btn btn-primary float-right ml-1 mr-1",
                    attrs: { to: _vm.$route.path + "/upload-video-lecture" }
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.$t(
                            "video_lectures.video_course.create_new_lecture"
                          )
                        ) +
                        "\n          "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    staticClass: "btn btn-primary float-right ml-1 mr-1",
                    attrs: { to: _vm.$route.path + "/edit" }
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("video_lectures.video_course.edit")) +
                        "\n          "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-primary float-right mr-1",
                    on: {
                      click: function($event) {
                        return _vm.$root.$emit(
                          "show::modal",
                          "remove-video-course-modal"
                        )
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("publishers.headers.actions.remove")) +
                        "\n          "
                    )
                  ]
                )
              ],
              1
            )
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _vm.loading
      ? _c(
          "div",
          {
            staticClass: "container mw-620 mt-4 pt-1",
            attrs: { slot: "layout-body" },
            slot: "layout-body"
          },
          [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-12 text-center" },
                [
                  _c("LoadingBounce"),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "typography--body-2 typography--color-disabled pb-5"
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("common.loading")) +
                          "\n        "
                      )
                    ]
                  )
                ],
                1
              )
            ])
          ]
        )
      : _c(
          "div",
          {
            staticClass: "container mw-620 mt-4 pt-1",
            attrs: { slot: "layout-body" },
            slot: "layout-body"
          },
          [
            _c("div", [
              _vm.courseDescription
                ? _c("div", {
                    staticClass: "typography--body-1 break-word-all",
                    domProps: { innerHTML: _vm._s(_vm.courseDescription) }
                  })
                : _c(
                    "div",
                    {
                      staticClass:
                        "typography--body-1 typography--color-disabled"
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("common.terms.no_description")) +
                          "\n      "
                      )
                    ]
                  )
            ]),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c(
              "draggable",
              {
                staticClass: "row",
                attrs: {
                  options: { handle: ".course-lecture-item__drag-handle" }
                },
                on: {
                  start: function($event) {
                    _vm.drag = true
                  },
                  end: function($event) {
                    _vm.drag = false
                  }
                },
                model: {
                  value: _vm.lectures,
                  callback: function($$v) {
                    _vm.lectures = $$v
                  },
                  expression: "lectures"
                }
              },
              [
                _vm.lectures.length === 0
                  ? _c("div", { staticClass: "col-12 text-center mb-5 pb-5" }, [
                      _c("div", { staticClass: "empty-list-text" }, [
                        _c("div", {
                          staticClass:
                            "typography--body-2 typography--color-disabled",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t("video_lectures.no_lectures")
                            )
                          }
                        })
                      ])
                    ])
                  : _vm._l(_vm.lectures, function(lecture, index) {
                      return _c(
                        "div",
                        {
                          key: lecture.id,
                          staticClass:
                            "col-12 video-course-details__lecture-row"
                        },
                        [
                          _c("CourseLectureItem", {
                            attrs: {
                              position: index + 1,
                              lecture: lecture,
                              "domain-concepts": _vm.domainConcepts,
                              "domain-name": _vm.courseDomainName
                            }
                          })
                        ],
                        1
                      )
                    }),
                _vm._v(" "),
                _c(
                  "InfiniteLoading",
                  {
                    ref: "infiniteLoading",
                    staticClass: "w-100",
                    attrs: { "on-infinite": _vm.onInfinite }
                  },
                  [
                    _c(
                      "div",
                      { attrs: { slot: "spinner" }, slot: "spinner" },
                      [
                        _c("LoadingBounce"),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "typography--body-2 typography--color-disabled pb-5"
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("common.loading")) +
                                "\n          "
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "col-12 text-center mb-5 pb-5",
                      attrs: { slot: "no-more" },
                      slot: "no-more"
                    })
                  ]
                )
              ],
              2
            )
          ],
          1
        ),
    _vm._v(" "),
    _c(
      "div",
      { attrs: { slot: "modal-area" }, slot: "modal-area" },
      [
        _c(
          "BasicModal",
          {
            attrs: {
              id: "remove-video-course-modal",
              title: _vm.$t("video_lectures.modals.remove_course.title")
            },
            on: {
              ok: function($event) {
                return _vm.removeCourse()
              }
            }
          },
          [
            _c("div", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("video_lectures.modals.remove_course.message")
                )
              }
            })
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d8a13bc6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d8a13bc6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/video-courses/views/VideoCourseDetails.vue
// module id = WmYt
// module chunks = 1